import React from "react";
import { Input, Button, Tooltip, Table, DatePicker, Popconfirm, message } from "antd";

import { SearchOutlined } from '@ant-design/icons';
import './index.sass'

import SkuEditor from "./com/skuEditor";
import api from "../../utils/api";
import UserInfo from "../../components/UserInfo";
import {MERCHANT_STATE} from "../../store/merchant";
import {TOKEN_STATE} from "../../store/token";
import {connect} from "react-redux";

class GoodsSku extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            showSku: null,
            dataSource: [],
            totalD: null,
            page: 1,
            total: 0
        }
    }

    componentDidMount() {
        this.getSumPro();
        this.getSpecs();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.token.value && nextProps.token.value !== this.props.token.value) {
            this.getSumPro();
            this.getSpecs();
        }
        return true;
    }

    show_sku = (item) => {
        console.log(item, '----------------')
        let { showSku } = this.state
        showSku = item;
        showSku.show = item.show
        this.setState({
            showSku
        })
    }

    getSumPro = async () => {

        let res = await api('sum-product-by-merchant');
        if (res.code === 200) {
            this.setState({
                totalD: res.data
            })
        }
    }

    delSku = async (ctx) => {
        await ctx

        let param = {
            spec_ids: (ctx.id).toString()
        }

        let res = await api('del-specs', param)
        if (res.code === 200) {
            message.success('删除成功！')
        } else {
            message.error(res.message)
        }
        //console.log(ctx, res)
    }

    editorClassify = (ctx) => {
        //console.log(ctx)


    }

    getSpecs = async () => {//获取商品规格列表
        let { page } = this.state;
        let param = {
            page,
            page_size: 15
        }
        let res = await api('get-specs', param);
        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }
        //console.log(res)
    }


    render() {
        let { showSku, dataSource, totalD } = this.state

        const columns = [
            {
                title: '规格分类',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '规格值',
                render: (ctx) => {
                    return (
                        <p>
                            {
                                ctx.values.map((item, index) => {
                                    return (<>
                                        <span>{item}</span>

                                        {
                                            index < ctx.values.length - 1 ? (<span>/</span>) : null
                                        }

                                    </>
                                    )
                                })
                            }
                        </p>
                    )
                }
            },
            {
                title: '操作',
                render: (ctx) => {
                    return (
                        <div className='flex alignCenter contrl'>
                            <Button className='mgr10' type='primary' size='small' onClick={() => {
                                //this.editorClassify(ctx)
                                this.show_sku({ show: true, type: 'changeSku', item: ctx })
                            }}>编辑</Button>

                            <Popconfirm
                                title="确认删除此规格?"
                                onConfirm={() => {
                                    this.delSku(ctx)
                                }}
                                okText="确定"
                                cancelText="取消"
                            >
                                <Button danger size='small' onClick={() => {
                                    this.show_sku({ show: false, type: 'delSku', item: ctx })
                                }}>删除</Button>
                            </Popconfirm>

                        </div>
                    )
                }
            },
        ];
        return (
            <div className='goodsClassify goodsSku'>
                {/* 头部 */}
                {
                    totalD ? (<UserInfo rightBox={<ul className='flex census'>
                        <li>
                            <label>全部商品</label>
                            <p>{totalD.product_num}</p>
                        </li>
                        <li>
                            <label>全部商品分类</label>
                            <p>{totalD.cate_num}</p>
                        </li>
                    </ul>} />) : null
                }
                <div className='record'>
                    <div className='change_fans flex' style={{ justifyContent: 'space-between' }}>

                        <div className='flex line alignCenter'>
                            搜索规格：
                            <Input placeholder='搜索规格：' />
                            <Button icon={<SearchOutlined />}>搜索</Button>

                            <Button>重置</Button>
                        </div>

                        <Button onClick={() => { this.show_sku({ show: true, type: 'newCLassify', item: null }) }} className='themeBtn'>添加规格</Button>

                    </div>
                    <div className='change_fans'>
                        <Table dataSource={dataSource} columns={columns} />
                    </div>
                </div>
                {
                    showSku && showSku.show ? (
                        <SkuEditor updateSku={(val) => { if (val) { this.getSpecs() } }} showSku={showSku} colsePop={(e) => { this.setState({ showSku: null }) }} />
                    ) : null
                }
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE],
        token: store[TOKEN_STATE]
    }
};
export default connect(mapStateToProps)(GoodsSku);